// extracted by mini-css-extract-plugin
module.exports = {"StepsToggler":"StepsToggler_StepsToggler__GaVfQ","Dark":"StepsToggler_Dark__2AZq5","Light":"StepsToggler_Light__BXpno"};